import useGetVehicle from '../hooks/useGetVehicle';
import Gallery from '../ui/Gallery';
import VehicleDealerImagePro from './VehicleDealerImagePro';

const VehicleGallery = () => {
  const { vehicle } = useGetVehicle();
  
  return (
    <div>
      {vehicle.hasDealerImageProPictures ? (
        <VehicleDealerImagePro vin={vehicle.vin} dealerImageProSellerId={vehicle.seller.dealerImageProSellerId} />
      ) : (
        <Gallery
          // min-h-0 fixes height issue
          className="w-full min-h-0 mb-8 md:mb-0"
          items={vehicle.pictures}
        />
      )}
    </div>
  );
};

export default VehicleGallery;